import * as React from "react";
import { Snackbar as MUISnackbar, useTheme } from "@mui/material";
import styled from "styled-components";
import Button from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";

const StyledMUISnackbar = styled(MUISnackbar)`
  .MuiSnackbarContent-root {
    ${({ theme, color }) => `background:${theme.palette.info[color] ?? color}`}
    border-radius: 8px !important;
  }

  button:focus {
    outline: none;
    box-shadow: none;
  }

  .MuiButton-root:hover {
    background-color: none;
  }

  .MuiButton-text {
    justify-content: end;
  }
`;

export const Snackbar = ({
  open,
  message,
  onClose,
  anchorOrigin = { vertical: "bottom", horizontal: "left" },
  color = "main",
  autoHideDuration = 10000,
  action = (
    <Button color="inherit" onClick={onClose} disableRipple>
      <CloseIcon fontSize="small" sx={{ textAlign: "right" }} />
    </Button>
  ),
}) => {
  const theme = useTheme();
  return (
    <StyledMUISnackbar
      {...{
        open,
        message,
        anchorOrigin,
        color,
        autoHideDuration,
        onClose,
        action,
        theme,
      }}
      sx={{ boxShadow: "lg" }}
    />
  );
};
